<app-tab-navigation-header title="Device" i18n-title="@@device-detailsDevice" [detail]="deviceName">
	<mat-tab-group appQueryStringTabGroup>
		@if (this.allowCodeGeneration && this.canViewGenerateCodes) {
			<mat-tab [label]="!finishedLoadingAllowCodeGen ? '' : generateCodeLabel" data-automation-id="generate-code-tab">
				<ng-template matTabContent>
					<div class="loading-container" [ngClass]="{ hide: finishedLoadingAllowCodeGen }">
						<mat-spinner diameter="25" style="float: left"></mat-spinner>
						<div style="float: left; margin-left: 1em" i18n="@@device-loadingDeviceData">Loading device data...</div>
					</div>
					<div [ngClass]="{ hide: !finishedLoadingAllowCodeGen }">
						@if (device) {
							<app-device-generate-code
								[appBreadcrumbLabel]="odcBreadcrumbLabel"
								[allowCodeGeneration]="allowCodeGeneration && canIssueFlexCodes"
								[deviceId]="deviceId"
								[userProfile]="userProfile"
								[device]="device"
								(deviceUpdatedEvents)="reloadDevice()"
							></app-device-generate-code>
						}
					</div>
				</ng-template>
			</mat-tab>
		}

		<mat-tab [label]="!finishedLoadingAllowCodeGen ? '' : detailsaboutLabel" data-automation-id="details-tab">
			<ng-template matTabContent>
				@if (!finishedLoadingAllowCodeGen || !device) {
					<div class="loading-container">
						<mat-spinner diameter="25" style="float: left"></mat-spinner>
						<div style="float: left; margin-left: 1em" i18n="@@device-loadingDeviceData">Loading device data...</div>
					</div>
				}
				@if (finishedLoadingAllowCodeGen && device) {
					<app-device-about
						[appBreadcrumbLabel]="aboutBreadcrumbLabel"
						[device]="device"
						[deviceInstallationPhotos]="deviceInstallationPhotos"
						[isHaspCodeGenFeatureEnabled]="isHaspCodeGenFeatureEnabled"
						[isInstallPhotoManagementFeatureEnabled]="isInstallPhotoManagementFeatureEnabled"
						[isTransferDeviceUpdatesFfEnabled]="transferDeviceUpdatesFF"
						(deviceUpdatedEvents)="reloadDevice()"
					></app-device-about>
				}
			</ng-template>
		</mat-tab>

		<mat-tab [label]="!finishedLoadingAllowCodeGen ? '' : notesLabel" data-automation-id="notes-tab">
			<ng-template matTabContent>
				<app-device-notes [appBreadcrumbLabel]="deviceNotesBreadcrumbLabel"></app-device-notes>
			</ng-template>
		</mat-tab>

		@if (canViewCompanyOrUserAccessTabs()) {
			<mat-tab [label]="!finishedLoadingAllowCodeGen ? '' : userAccessLabel" data-automation-id="user-access-tab">
				<ng-template matTabContent>
					<app-user-access
						[appBreadcrumbLabel]="deviceUsersBreadcrumbLabel"
						[devices]="this.devices"
						[companyId]="activeCompanyId"
						[deviceId]="this.deviceId"
						[hasOnlyPDQ]="hasOnlyPDQ"
						[hasSentriVaultDevice]="hasSentriVaultDevice"
					></app-user-access>
				</ng-template>
			</mat-tab>
		}

		@if (canViewCompanyOrUserAccessTabs()) {
			<mat-tab [label]="!finishedLoadingAllowCodeGen ? '' : companyAccessLabel" data-automation-id="company-access-tab">
				<ng-template matTabContent>
					<app-company-access
						[appBreadcrumbLabel]="deviceCompaniesBreadcrumbLabel"
						[devices]="this.devices"
						[companyId]="activeCompanyId"
						[deviceId]="this.deviceId"
						[hasOnlyPDQ]="hasOnlyPDQ"
						[hasSentriVaultDevice]="hasSentriVaultDevice"
					></app-company-access>
				</ng-template>
			</mat-tab>
		}

		@if (this.canAccessEventHistory) {
			<mat-tab [label]="!finishedLoadingAllowCodeGen ? '' : eventHistoryLabel" data-automation-id="event-history-tab">
				<ng-template matTabContent>
					<app-device-event-history
						[deviceId]="deviceId"
						[device]="device"
						[userProfile]="userProfile"
						[appBreadcrumbLabel]="eventHistoryBreadcrumbLabel"
					></app-device-event-history>
				</ng-template>
			</mat-tab>
		}

		@if (this.canAccessAuditLogs) {
			<mat-tab [label]="!finishedLoadingAllowCodeGen ? '' : auditLogLabel" data-automation-id="audit-log-tab">
				<ng-template matTabContent>
					<app-audit-log-list
						[deviceId]="deviceId"
						[appBreadcrumbLabel]="auditLogBreadcrumbLabel"
						[hiddenColumns]="hiddenAuditLogColumns"
					></app-audit-log-list>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
